import { useQueryClient, useMutation } from '@tanstack/react-query';
import { key as structuralHierachyKey } from "../queries/useStructuralHierachyQuery";
import { key as locationKey } from "../queries/useLocationQuery";
import { updateLocation } from "../orgPanelApiCalls";
import { useStore } from "../appStore";
import { saveToLocalStorage, StorageKeys } from '../localStorageHelper';

const useUpdateLocationMutation = () => {
    const queryClient = useQueryClient()
    const orgId = useStore((state) => state.CurrentOrganizationId);

    return useMutation({
        mutationFn: async (variables) => await updateLocation(orgId, variables.id, variables.location),
        onSuccess: (data) => {

            //add the new record to cache
            queryClient.setQueryData([structuralHierachyKey], (previousData) => {
                return previousData.map((item) => {

                    if (item.accountId === data.accountId) {
                        return {
                            ...item,
                            name: data.locationName,
                            parentId: data.parentAccountId
                        }
                    }

                    return item;
                });
            });

            queryClient.invalidateQueries([locationKey, data.accountId]);
            saveToLocalStorage(StorageKeys.LOCATION(data.accountId), data);
        }
    })
}

export { useUpdateLocationMutation };